import { paramCase } from "src/utils/change-case";

import { _id, _postTitles } from "src/_mock/assets";

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: "/auth",
  PLAYER: "/player",
  TOURNAMENT: "/tournament",
  SPORTPROVIDER: "/sportprovider",
  AUTH_DEMO: "/auth-demo",
  DASHBOARD: "/dashboard",
};

// ----------------------------------------------------------------------

export const paths = {
  home: "/",
  partner_coach: "/partner-coach",
  partner_clubandcourt: "/partner-clubandcourt",
  partner_tournament_organiser: "/partner-tournament-organiser",
  partner_player: "/partner-player",
  partner_disabled_people_program: "/partner-disabled-people-program",

  sportmates: {
    root: `/sportmates`,
    //details: (title: string) => `/sportmates/${paramCase(title)}`,
    rankings: (sport: string) => `/sportmates/rankings/${paramCase(sport)}`,
    details: (id: number) => `/sportmates/${id}`,
    create: `/sportmates/create`,
    myapplications: `/sportmates/myapplications`,
    edit: (id: number) => `/sportmates/edit/${id}`,
    landing: `/sportmates/landing`,
    successful_subscription: `/sportmates/successful-subscription`,
  },
  introduction: "/introduction",
  partners: "/partners",

  sportproviders: "/sportproviders",
  tournaments: "/tournaments",
  // components: "/components",

  comingSoon: "/coming-soon",
  //maintenance: "/maintenance",
  pricing: "/#pricing",
  payment: "/payment",
  about: "/about-us",
  contact: "/contact-us",
  faqs: "/faqs",
  terms_and_conditions: "/terms-and-conditions",
  privacy_policy: "/privacy-policy",
  code_of_ethics: "/code-of-ethics",
  user_manual: "/user-manual",
  page403: "/403",
  page404: "/404",
  page500: "/500",
  components: "/components",
  custom_components: "/custom-components",
  checkout: `/checkout`,
  partnerfinder: `/partnerfinder`,
  feedback: `/feedback`,
  tokenusage: `/tokenusage`,
  training_package: `/training-package`,
  counties_and_providers: `/counties-and-providers`,

  // checkout: {
  //   checkout: (id: number, step: number) => `/checkout/${id}/${step}/checkout`,
  // },
  // AUTH
  auth: {
    jwt: {
      login: `/login`,
      register: `/register`,
      verify: `${ROOTS.AUTH}/jwt/verify`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      newPassword: `${ROOTS.AUTH}/jwt/new-password`,
    },
  },
  player: {
    overview: `${ROOTS.PLAYER}/overview`,
    providers: `${ROOTS.PLAYER}/providers`,
    bookings: `${ROOTS.PLAYER}/bookings`,
    activities: `${ROOTS.PLAYER}/activities`,
    passestickets: `${ROOTS.PLAYER}/passes-tickets`,
    tournamentapplications: `${ROOTS.PLAYER}/tournamentapplications`,
    // passes: `${ROOTS.PLAYER}/passes`,
    //tickets: `${ROOTS.PLAYER}/tickets`,
    waitinglist: `${ROOTS.PLAYER}/waitinglist`,
    teams: `${ROOTS.PLAYER}/teams`,
    messages: `${ROOTS.PLAYER}/messages`,
    results: `${ROOTS.PLAYER}/results`,
    profiledata: `${ROOTS.PLAYER}/profiledata`,
    //edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
  },
  sportprovider: {
    profile: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/profile`,
    newsfeed: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/newsfeed`,
    trainings: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/trainings`,
    results: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/results`,
    events: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/events`,
    championships: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/championships`,
    tournaments: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/tournaments`,
    rankings: (id: string, rankingId: number) =>
      `${ROOTS.SPORTPROVIDER}/${id}/rankings${
        rankingId ? `/${rankingId}` : ""
      }`,
    venues: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/venues`,
    calendar: (id: string, resourceId?: number) =>
      `${ROOTS.SPORTPROVIDER}/${id}/calendar${
        resourceId ? `/${resourceId}` : ""
      }`,
    livecalendar: (id: string, resourceId?: number) =>
      `${ROOTS.SPORTPROVIDER}/${id}/livecalendar${
        resourceId ? `/${resourceId}` : ""
      }`,
    // calendar: (
    //   id: string,
    //   resourceId?: number,
    //   date?: string,
    //   eventId?: string
    // ) => {
    //   let path = `${ROOTS.SPORTPROVIDER}/${id}/calendar`;

    //   if (resourceId) {
    //     path += `/${resourceId}`;
    //   }

    //   if (date) {
    //     path += `/date-${date}`; // Ensures date isn't treated as a resourceId
    //   }

    //   if (eventId) {
    //     path += `/event-${eventId}`; // Ensures eventId isn't confused with resourceId
    //   }

    //   return path;
    // },
    passes: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/passes`,
    tickets: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/tickets`,
    services: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/services`,
    camps: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/camps`,
    rules: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/rules`,
    prices: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/prices`,
    livestreaming: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/livestreaming`,
    //edit: (id: string) => `${ROOTS.SPORTPROVIDER}/${id}/edit`,
  },

  tournament: {
    list: (provider: string) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments`,

    profile: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/profile`,

    schedule: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/schedule`,

    application: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/application`,

    results: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/results`,

    participants: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/participants`,

    rules: (provider: string, id: number) =>
      `${ROOTS.SPORTPROVIDER}/${provider}/tournaments/${id}/rules`,
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    applications: `${ROOTS.DASHBOARD}/finances`,
    athletes: `${ROOTS.DASHBOARD}/athletes`,
    // finances: `${ROOTS.DASHBOARD}/finances`,
    analytics: `${ROOTS.DASHBOARD}/analytics`,
    payment_management: `${ROOTS.DASHBOARD}/payment-management`,
    adminuser_management: `${ROOTS.DASHBOARD}/adminuser-management`,
    livestreaming: `${ROOTS.DASHBOARD}/livestreaming`,
    //profile: `${ROOTS.DASHBOARD}/profile`,
    //settings: `${ROOTS.DASHBOARD}/settings`,
    settings: {
      root: `${ROOTS.DASHBOARD}/settings`,
      global: `${ROOTS.DASHBOARD}/settings/global`,
      pricing: `${ROOTS.DASHBOARD}/settings/pricing`,
      venue: {
        root: `${ROOTS.DASHBOARD}/settings/venue`,
        new: `${ROOTS.DASHBOARD}/settings/venue/new`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/settings/venue/${id}/edit`,
      },
      training: {
        root: `${ROOTS.DASHBOARD}/settings/training`,
        new: `${ROOTS.DASHBOARD}/settings/training/new`,
        edit: (id: number) => `${ROOTS.DASHBOARD}/settings/training/${id}/edit`,
      },
      // course: `${ROOTS.DASHBOARD}/event/course`,
      blocking: {
        root: `${ROOTS.DASHBOARD}/settings/blocking`,
        new: `${ROOTS.DASHBOARD}/settings/blocking/new`,
        edit: (id: string) => `${ROOTS.DASHBOARD}/settings/blocking/${id}/edit`,
      },
      passestickets: {
        root: `${ROOTS.DASHBOARD}/settings/passes-tickets`,
        passes: `${ROOTS.DASHBOARD}/settings/passes-tickets/passes`,
        tickets: `${ROOTS.DASHBOARD}/settings/passes-tickets/tickets`,
        newpass: `${ROOTS.DASHBOARD}/settings/passes-tickets/passes/new`,
        newticket: `${ROOTS.DASHBOARD}/settings/passes-tickets/tickets/new`,
        editpass: (id: number) =>
          `${ROOTS.DASHBOARD}/settings/passes-tickets/passes/${id}/edit`,
        editticket: (id: number) =>
          `${ROOTS.DASHBOARD}/settings/passes-tickets/tickets/${id}/edit`,
      },

      // `${ROOTS.DASHBOARD}/event/blocking`,
    },
    profile: {
      root: `${ROOTS.DASHBOARD}/profile`,
      data: `${ROOTS.DASHBOARD}/profile/data`,
      images: `${ROOTS.DASHBOARD}/profile/images`,
      sports: `${ROOTS.DASHBOARD}/profile/sports`,
      venues: `${ROOTS.DASHBOARD}/profile/venues`,
      billing_infos: `${ROOTS.DASHBOARD}/profile/billing-infos`,
      staff: `${ROOTS.DASHBOARD}/profile/staff`,
    },
    organiser: {
      home: `${ROOTS.DASHBOARD}/organiser/home`,
      profile: {
        root: `${ROOTS.DASHBOARD}/organiser/profile`,
        data: `${ROOTS.DASHBOARD}/organiser/profile/data`,
      },
      tournaments: `${ROOTS.DASHBOARD}/organiser/tournaments`,
      tournament: {
        profile: (id: number) =>
          `${ROOTS.DASHBOARD}/organiser/tournament/${id}/profile`,
        management: (id: number) =>
          `${ROOTS.DASHBOARD}/organiser/tournament/${id}/management`,
        new: `${ROOTS.DASHBOARD}/organiser/tournament/new`,
        edit: (id: number) =>
          `${ROOTS.DASHBOARD}/organiser/tournament/${id}/edit`,
        applications: (id: number) =>
          `${ROOTS.DASHBOARD}/organiser/tournament/${id}/applications`,
        rules: (id: number) =>
          `${ROOTS.DASHBOARD}/organiser/tournament/${id}/rules`,
      },
      //players_and_teams: `${ROOTS.DASHBOARD}/organiser/players-and-teams`,
      players_and_teams: {
        root: `${ROOTS.DASHBOARD}/organiser/players-and-teams`,
        players: `${ROOTS.DASHBOARD}/organiser/players-and-teams/players`,
        teams: `${ROOTS.DASHBOARD}/organiser/players-and-teams/teams`,
      },
      rankings: `${ROOTS.DASHBOARD}/organiser/rankings`,
      settings: {
        root: `${ROOTS.DASHBOARD}/settings`,
        global: `${ROOTS.DASHBOARD}/organiser/settings/global`,
      },
      analytics: `${ROOTS.DASHBOARD}/organiser/analytics`,
      payment_management: `${ROOTS.DASHBOARD}/organiser/payment-management`,
      livestreaming: `${ROOTS.DASHBOARD}/organiser/livestreaming`,
    },

    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      // details: (title: string) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      details: (id: number) => `${ROOTS.DASHBOARD}/post/${id}`,
      // edit: (title: string) =>
      //   `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      edit: (id: number) => `${ROOTS.DASHBOARD}/post/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id: string) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
  },
  docs: "https://docs.minimals.cc",
  changelog: "https://docs.minimals.cc/changelog",
  zoneUI: "https://mui.com/store/items/zone-landing-page/",
  minimalUI: "https://mui.com/store/items/minimal-dashboard/",
  freeUI: "https://mui.com/store/items/minimal-dashboard-free/",

  figma:
    "https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0",
  product: {
    root: `/product`,
    // checkout: `/product/checkout`,
    details: (id: string) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    //details: (title: string) => `/post/${paramCase(title)}`,
    details: (id: number) => `/post/${id}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
};
